import React from 'react';
import { SvgIcon } from '../../components/svgIcon';
import { SvgIconProps } from '../../components/svgIcon/model';

export const UsersHatchedIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      // cacheName="hatched/users"
      ref={ref as any}
      {...props}
    >
      <g clipPath="url(#clip0_302_7)">
        <mask height="22" id="mask0_302_7" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }} width="22" x="3" y="3">
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 23.5936C5.45881 18.8554 6.88626 16.072 7.9686 14.3675C8.34509 13.789 8.95685 12.8663 9.74116 11.3964C10.7294 9.55125 10.949 8.73809 11.8901 7.018C12.3137 6.23613 12.9254 5.18843 13.7725 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 19.3245C4.54902 18.3394 4.97254 17.495 5.30195 16.8226C5.59999 16.1971 6.05489 15.2588 6.55685 14.0079C7.05881 12.7569 7.07449 12.5223 7.49802 11.6623C7.95292 10.724 8.04705 10.7866 8.48623 9.89528C9.05095 8.73809 8.90977 8.62864 9.53721 7.28383C10.0392 6.18922 10.5098 5.46991 10.6823 5.20407C11.0117 4.70368 11.3255 4.29711 11.5764 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            fill="#FFCEC3"
          />
          <path
            d="M4 16.0407C4.15686 15.556 4.43921 14.7585 4.84705 13.8202C5.27058 12.8664 5.41176 12.6943 6.10195 11.2088C6.58822 10.1611 6.58822 10.0986 7.15292 8.91011C7.63919 7.87804 7.749 7.6904 8.06273 7.03364C8.39214 6.3456 8.84704 5.31354 9.31762 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 11.9435C4.48627 10.7707 4.94117 9.83243 5.27058 9.20697C5.8196 8.12797 6.10195 7.6745 6.63528 6.64243C7.1843 5.53218 7.57645 4.60958 7.82742 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 8.61272C4.21961 8.15927 4.43921 7.70577 4.64313 7.22101C4.98823 6.43915 5.09803 6.09513 5.41176 5.42272C5.56862 5.06307 5.80391 4.57831 6.10195 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            fill="#FFCEC3"
          />
          <path
            d="M4 5.28199C4.1098 5.14125 4.26667 4.93797 4.39216 4.68777C4.51764 4.42194 4.59608 4.18738 4.64313 4.01537"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            fill="#FFCEC3"
          />
          <path
            d="M5.19214 23.9063C5.41174 23.5466 5.75684 22.9837 6.10194 22.2487C6.72939 20.9352 6.8235 20.2628 7.3882 18.8398C7.89017 17.5732 8.37644 16.6506 8.64312 16.1658C9.49015 14.5864 9.74115 14.5396 10.7294 12.8038C11.498 11.459 11.3411 11.5059 12.2666 9.84835C13.1293 8.2846 13.396 8.0188 13.9764 6.8929C14.5882 5.68883 14.9803 4.64113 15.1999 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            fill="#FFCEC3"
          />
          <path
            d="M6.72949 23.9063C7.09027 23.4684 7.60792 22.796 8.15692 21.9047C9.14517 20.2941 9.25495 19.5122 10.4157 16.8695C11.0902 15.337 11.4824 14.4614 12.1569 13.2885C12.9726 11.8812 13.1922 11.8187 14.353 9.87961C14.9177 8.95704 15.4824 8.00317 16.0941 6.68962C16.5961 5.61064 16.9412 4.68804 17.1765 4"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.6122 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            fill="#FFCEC3"
          />
          <path
            d="M9.01965 23.9063C9.28633 23.3277 9.63142 22.5615 10.0706 21.6702C11.0902 19.5122 11.8902 17.9172 12.0942 17.5419C12.5177 16.7131 13.2549 15.2589 14.2118 13.4762C15.2941 11.4746 15.4823 11.24 16.2667 9.69197C16.8314 8.58171 17.302 7.61221 17.6941 6.8147C18.2274 5.70446 18.6823 4.75058 19.0117 4.01562"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 4.39096C22.541 9.12905 21.1136 11.9125 20.0313 13.617C19.6548 14.1956 19.043 15.1182 18.2587 16.5881C17.2705 18.4333 17.0509 19.2464 16.1097 20.9665C15.6862 21.7484 15.0744 22.7961 14.2274 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            fill="#FFCEC3"
          />
          <path
            d="M24 8.67541C23.451 9.66058 23.0117 10.505 22.698 11.1774C22.4 11.8029 21.9451 12.7411 21.4431 13.9921C20.9411 15.2431 20.9255 15.4776 20.502 16.3377C20.0471 17.2759 19.9529 17.2134 19.5137 18.1047C18.9333 19.2462 19.0745 19.3713 18.4628 20.7005C17.9608 21.7951 17.4902 22.5144 17.3176 22.7803C16.9882 23.2807 16.6745 23.6872 16.4235 23.9843"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            fill="#FFCEC3"
          />
          <path
            d="M24 11.9593C23.8431 12.444 23.5608 13.2415 23.1529 14.1798C22.7294 15.1336 22.5882 15.3057 21.898 16.7912C21.4118 17.8389 21.4118 17.9015 20.847 19.0899C20.3608 20.1219 20.251 20.3096 19.9372 20.9664C19.6078 21.6544 19.1529 22.6865 18.6823 24"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 16.0563C23.4979 17.2291 23.043 18.1673 22.7293 18.7928C22.1803 19.8718 21.8979 20.3252 21.3646 21.3573C20.8156 22.4676 20.4234 23.3902 20.1724 23.9844"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            fill="#FFCEC3"
          />
          <path
            d="M23.9999 19.3872C23.7802 19.8406 23.5606 20.2941 23.3567 20.7789C23.0116 21.5608 22.9018 21.9048 22.5881 22.5772C22.4312 22.9368 22.1959 23.4216 21.8979 23.9845"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M23.9998 22.7179C23.8744 22.8587 23.7332 23.0463 23.592 23.3121C23.4665 23.578 23.3881 23.8125 23.341 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            fill="#FFCEC3"
          />
          <path
            d="M22.7921 4.07827C22.5725 4.43793 22.2274 5.00087 21.8823 5.72019C21.2548 7.03372 21.1607 7.70612 20.596 9.12914C20.0941 10.3957 19.6078 11.3184 19.3411 11.8031C18.4941 13.3825 18.2431 13.4294 17.2549 15.1651C16.4863 16.5099 16.6431 16.463 15.7176 18.1206C14.8549 19.6843 14.5882 19.9501 14.0078 21.076C13.3961 22.2801 13.0039 23.3278 12.7843 23.9689"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            fill="#FFCEC3"
          />
          <path
            d="M21.2704 4.07827C20.9096 4.51611 20.392 5.18852 19.843 6.07985C18.8547 7.69049 18.7449 8.47237 17.5842 11.1151C16.9096 12.6475 16.5175 13.5232 15.843 14.696C15.0273 16.1033 14.8077 16.1659 13.6469 18.1049C13.0822 19.0275 12.5175 19.9814 11.9057 21.2949C11.4038 22.3739 11.0587 23.2965 10.8234 23.9846"
            stroke="#FFCEC3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="0.7"
          />
        </mask>
        <g mask="url(#mask0_302_7)">
          <path
            d="M13.9922 24.1095C19.58 24.1095 24.1098 19.5833 24.1098 14C24.1098 8.41669 19.58 3.8905 13.9922 3.8905C8.40437 3.8905 3.87457 8.41669 3.87457 14C3.87457 19.5833 8.40437 24.1095 13.9922 24.1095Z"
            fill="#FFCEC3"
          />
        </g>
        <path
          d="M17.0169 8.17711L15.779 7.8831V7.39491C16.4661 6.96313 16.9237 6.20166 16.9237 5.33552V3.96057C16.9237 2.61786 15.825 1.52552 14.4744 1.52552C13.7459 1.52552 13.091 1.84377 12.642 2.34735C12.2487 0.993204 10.9908 0 9.50386 0H9.50382C8.01447 0 6.75487 0.99634 6.36378 2.35381C5.9146 1.8465 5.25732 1.52552 4.52567 1.52552C3.17512 1.52552 2.07638 2.6179 2.07638 3.96057V5.33552C2.07638 6.2017 2.53401 6.96316 3.22113 7.39491V7.8831L1.98324 8.17711C0.815516 8.45441 0 9.48167 0 10.6752V13.1553C0 13.359 0.166176 13.5242 0.371094 13.5242H3.33847V14.6311C3.33847 14.8348 3.50465 15 3.70956 15H7.78061C7.98553 15 8.15171 14.8348 8.15171 14.6311C8.15171 14.4273 7.98553 14.2621 7.78061 14.2621H6.12394V12.6383C6.12394 12.4345 5.95776 12.2694 5.75284 12.2694C5.54793 12.2694 5.38175 12.4345 5.38175 12.6383V14.2621H4.08062V12.5975C4.08062 11.3462 4.9354 10.2687 6.1593 9.97716L7.98445 9.54232L9.15882 12.1986C9.21804 12.3326 9.3513 12.4191 9.49848 12.4191H9.49852C9.64569 12.4191 9.77899 12.3326 9.83822 12.1986L11.0114 9.54623L12.8312 9.97845C14.0563 10.2694 14.9118 11.3471 14.9118 12.5992V13.0109C14.8928 13.0553 14.8823 13.104 14.8823 13.1552C14.8823 13.2064 14.8928 13.2552 14.9118 13.2995V14.2621H13.6183V12.6383C13.6183 12.4345 13.4521 12.2694 13.2472 12.2694C13.0422 12.2694 12.8761 12.4345 12.8761 12.6383V14.2621H11.0586C10.8537 14.2621 10.6875 14.4273 10.6875 14.6311C10.6875 14.8348 10.8537 15 11.0586 15H15.2829C15.4878 15 15.654 14.8348 15.654 14.6311V13.5242H18.6289C18.8338 13.5242 19 13.359 19 13.1553V10.6752C19 9.48167 18.1845 8.45441 17.0169 8.17711ZM14.4744 2.26341C15.4157 2.26341 16.1815 3.02477 16.1815 3.96057V4.05192V4.089H15.1201C14.3183 4.089 13.5304 3.87969 12.8361 3.48297C13.0441 2.77894 13.6998 2.26341 14.4744 2.26341ZM12.7673 5.27531C12.7686 5.23764 12.7695 4.28328 12.7695 4.28328C13.4991 4.63998 14.3033 4.82693 15.1201 4.82693H16.1815V5.33556C16.1815 6.27135 15.4157 7.03267 14.4744 7.03267C13.5331 7.03267 12.7673 6.27132 12.7673 5.33552V5.27531ZM6.98027 3.24677C6.98027 1.86336 8.11233 0.73793 9.50382 0.73793C10.8953 0.73793 12.0273 1.8634 12.0273 3.24677V3.29488L10.65 2.49039C10.4938 2.39907 10.294 2.43342 10.1776 2.57152C9.6425 3.2064 8.85771 3.57055 8.02449 3.57055H6.98027V3.24677ZM2.81849 4.05196V3.96057C2.81849 3.02473 3.58432 2.26341 4.5256 2.26341C5.30018 2.26341 5.95591 2.77894 6.1639 3.483C5.46955 3.87969 4.68172 4.08903 3.8799 4.08903H2.81849V4.05196ZM2.81849 5.33552V4.82689H3.87993C4.69753 4.82689 5.50262 4.63961 6.23271 4.28222V5.33552C6.23271 6.27135 5.46688 7.03267 4.5256 7.03267C3.58432 7.03267 2.81849 6.27132 2.81849 5.33552ZM3.33847 12.5975V12.7863H2.22656V11.1471C2.22656 10.9434 2.06039 10.7782 1.85547 10.7782C1.65055 10.7782 1.48438 10.9434 1.48438 11.1471V12.7863H0.742188V10.6752C0.742188 9.82457 1.32339 9.09247 2.15557 8.89482L3.33187 8.61542L4.09958 10.4437C3.61943 11.0368 3.33847 11.7885 3.33847 12.5975ZM4.52567 9.54306L3.96209 8.20087C3.96272 8.19205 3.96324 8.18323 3.96324 8.17431V7.70508C4.14393 7.74743 4.33207 7.77057 4.5256 7.77057C4.71827 7.77057 4.90553 7.74762 5.08551 7.70563V8.15095C5.0851 8.15789 5.08491 8.16482 5.08491 8.17176C5.08491 8.18338 5.08603 8.19493 5.08714 8.20648L4.52567 9.54306ZM5.98637 9.2596C5.76724 9.31181 5.55783 9.38445 5.359 9.47403L5.72045 8.61357L6.89693 8.89386C6.98818 8.91559 7.07709 8.94433 7.16315 8.97924L5.98637 9.2596ZM7.82833 8.4906C7.59536 8.34694 7.33975 8.24057 7.06989 8.1763L5.82769 7.88037V7.39649C6.13663 7.20291 6.39903 6.94273 6.59463 6.6362C6.8744 7.17963 7.30379 7.63468 7.82833 7.9477V8.4906V8.4906ZM10.4252 9.0383L9.49859 11.1334L8.57052 9.03421V8.27329C8.86636 8.36118 9.1796 8.40859 9.50378 8.40859C9.82367 8.40859 10.1329 8.36239 10.4252 8.27676V9.0383ZM9.50382 7.67073C8.11229 7.67069 6.98027 6.54522 6.98027 5.16186V4.30848H8.02446C8.97164 4.30848 9.86935 3.93629 10.5326 3.27761L12.0251 4.14939V5.24845C11.979 6.59182 10.8661 7.67073 9.50382 7.67073ZM11.1674 7.95463H11.1675C11.6952 7.64269 12.1276 7.1873 12.4096 6.6427C12.6048 6.94638 12.8656 7.20423 13.1723 7.39649V7.88037L11.9301 8.1763C11.6586 8.24097 11.4016 8.3483 11.1674 8.4933V7.95463V7.95463ZM13.0036 9.26082L11.8301 8.98204C11.9182 8.94588 12.0094 8.91618 12.1031 8.89386L13.2767 8.61427L13.6396 9.47857C13.4382 9.38736 13.2259 9.31361 13.0036 9.26082ZM13.9121 8.21197C13.9136 8.19858 13.9146 8.18512 13.9146 8.17161C13.9146 8.16818 13.9146 8.16471 13.9145 8.16128V7.70563C14.0945 7.74766 14.2817 7.77057 14.4744 7.77057C14.6679 7.77057 14.8561 7.74743 15.0368 7.70504V8.17427C15.0368 8.18098 15.0372 8.18759 15.0376 8.19423L14.471 9.54306L13.9121 8.21197ZM18.2578 12.7863H17.5156V11.1471C17.5156 10.9434 17.3494 10.7782 17.1445 10.7782C16.9396 10.7782 16.7734 10.9434 16.7734 11.1471V12.7863H15.654V12.5993C15.654 11.7913 15.3739 11.0407 14.8951 10.4481L15.6653 8.61475L16.8444 8.89482C17.6766 9.09247 18.2578 9.82457 18.2578 10.6752V12.7863V12.7863Z"
          fill="#FF7870"
        />
      </g>
    </SvgIcon>
  );
});
